import { Component } from '@angular/core'

@Component({
  selector: 'vdr-app-auth',
  templateUrl: './app-auth.component.html',
  styleUrls: ['./app-auth.component.scss']
})
export class AppAuthComponent {}
